import iconPartial from 'views/partials/icon';
import labelPartial from 'views/partials/label';
import localeSpanPartial from 'views/partials/locale-span';

export default {
  icon: iconPartial,
  label: labelPartial,
  localeSpan: localeSpanPartial,
};
